import React, { useState } from 'react';
import { Copy, Check } from 'lucide-react';

export const CopyableBlock = ({ label, content, mono = false, testId }) => {
  const [copied, setCopied] = useState(false);

  const handleCopy = async () => {
    try {
      await navigator.clipboard.writeText(content || '');
      setCopied(true);
      setTimeout(() => setCopied(false), 1500);
    } catch (e) {
      // noop
    }
  };

  if (!content) return null;

  return (
    <div className="mb-4">
      {label && (
        <div className="flex items-center justify-between mb-2">
          <span className="text-xs font-semibold uppercase tracking-wide text-gray-500">
            {label}
          </span>
          <button
            type="button"
            onClick={handleCopy}
            data-testid={testId || `copy-${label?.toLowerCase().replace(/\s+/g, '-')}`}
            className="text-xs flex items-center gap-1 text-[#07743F] hover:text-[#0a8f4d] transition"
          >
            {copied ? (
              <>
                <Check className="w-3 h-3" /> Copied
              </>
            ) : (
              <>
                <Copy className="w-3 h-3" /> Copy
              </>
            )}
          </button>
        </div>
      )}
      <pre
        className={`whitespace-pre-wrap text-sm text-gray-800 bg-gray-50 border border-gray-200 rounded-lg p-3 leading-relaxed ${
          mono ? 'font-mono text-xs' : ''
        }`}
      >
        {content}
      </pre>
    </div>
  );
};

export default CopyableBlock;
